/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createHttpValidationProblemDetailsFromDiscriminatorValue, createIErrorFromDiscriminatorValue, createPaginatedResultOfPendingRevisionResponseFromDiscriminatorValue, type HttpValidationProblemDetails, type IError, type PaginatedResultOfPendingRevisionResponse } from '../../../../models/index.js';
// @ts-ignore
import { type WithRevisionItemRequestBuilder, WithRevisionItemRequestBuilderNavigationMetadata } from './item/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Guid, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /files/{file-id}/revisions/pending
 */
export interface PendingRequestBuilder extends BaseRequestBuilder<PendingRequestBuilder> {
    /**
     * Gets an item from the ApiSdk.files.item.revisions.pending.item collection
     * @param revisionId Unique identifier of the item
     * @returns {WithRevisionItemRequestBuilder}
     */
     byRevisionId(revisionId: Guid) : WithRevisionItemRequestBuilder;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<PaginatedResultOfPendingRevisionResponse>}
     * @throws {HttpValidationProblemDetails} error when the service returns a 400 status code
     * @throws {IError} error when the service returns a 404 status code
     * @throws {IError} error when the service returns a 409 status code
     */
     get(requestConfiguration?: RequestConfiguration<PendingRequestBuilderGetQueryParameters> | undefined) : Promise<PaginatedResultOfPendingRevisionResponse | undefined>;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<PendingRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
export interface PendingRequestBuilderGetQueryParameters {
    page?: number;
    pageSize?: number;
}
/**
 * Uri template for the request builder.
 */
export const PendingRequestBuilderUriTemplate = "{+baseurl}/files/{file%2Did}/revisions/pending{?page*,pageSize*}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const PendingRequestBuilderNavigationMetadata: Record<Exclude<keyof PendingRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byRevisionId: {
        navigationMetadata: WithRevisionItemRequestBuilderNavigationMetadata,
        pathParametersMappings: ["revisionId"],
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const PendingRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: PendingRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createHttpValidationProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createIErrorFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createIErrorFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createPaginatedResultOfPendingRevisionResponseFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
